import * as PageResponsive from "components/utility/page-responsive/PageResponsive";

let resizeListenerRegistered = false;
let loadListenerRegistered = false;

const DESCRIPTION_SELECTOR =
	".collection-page-card-description, .collection-card-utility-description";
const CARD_SELECTOR = ".content-card-wrapper, .collection-page-card, .collection-card-utility";
const GRID_ITEM_SELECTOR = `${DESCRIPTION_SELECTOR}, ${CARD_SELECTOR}`;

const isDescriptionCard = (card) =>
	card.classList.contains("collection-page-card-description") ||
	card.classList.contains("collection-card-utility-description");

const getGridItems = (collection) =>
	[...collection.querySelectorAll(GRID_ITEM_SELECTOR)].filter(
		(card) =>
			isDescriptionCard(card) ||
			card.classList.contains("content-card-wrapper") ||
			!card.closest(".content-card-wrapper")
	);

const getDescriptionCardSpan = (card, columns) => {
	if (card.classList.contains("content-card-last")) {
		return columns !== 2 ? 1 : 2;
	}

	if (card.classList.contains("collection-page-card-description-1x")) {
		return columns === 3 ? 2 : 1;
	}

	if (card.classList.contains("collection-page-card-description-2x")) {
		return columns === 3 ? 1 : 2;
	}

	return 2;
};

// This function counts each card taking into account if that card is a description card
const cardCounter = (cards, columns) => {
	let count = 0;

	cards.forEach((card) => {
		if (isDescriptionCard(card)) {
			count += getDescriptionCardSpan(card, columns);
		} else {
			count++;
		}
	});

	return count;
};

// This function creates a card array with description cards and collection cards
const cardSorter = (collection) => getGridItems(collection);

// This function decides if an empty collection card is going to be added for representing the right border of the last actual collection card
const initializeLastCardGridline = () => {
	document.querySelectorAll(".content-card-last").forEach((card) => {
		card.remove();
	});

	if (!PageResponsive.isMobile()) {
		let columns;

		if (PageResponsive.isContentMax()) columns = 4;
		else if (PageResponsive.isDesktop()) columns = 3;
		else if (PageResponsive.isTablet()) columns = 2;

		// TODO: Test retarget
		// document.querySelectorAll(".collection-page-section", ".content").forEach((collection) => {
		document.querySelectorAll(".content-cards-grid").forEach((collection) => {
			const cards = cardSorter(collection);
			if (cards.length) {
				const count = cardCounter(cards, columns);

				// Add an empty card if the last row is not complete, meaning that the count of cards is not divisible by the number of columns. This empty card will have the "content-card-last" class which adds a right border to simulate the gridline
				if (count % columns !== 0) {
					const lastCard = cards.pop();
					const emptyCard = document.createElement("div");
					emptyCard.classList.add("collection-card-utility-description", "content-card-last");
					lastCard.parentNode.appendChild(emptyCard);
				}
			}
		});
	}
};

const initializeWhenPageLoaded = () => {
	if (document.readyState === "complete") {
		initializeLastCardGridline();
		return;
	}

	if (!loadListenerRegistered) {
		window.addEventListener(
			"load",
			() => {
				initializeLastCardGridline();
				loadListenerRegistered = false;
			},
			{ once: true }
		);
		loadListenerRegistered = true;
	}
};

export const collectionPageGridline = async () => {
	initializeWhenPageLoaded();
	if (!resizeListenerRegistered) {
		window.addEventListener("resize", initializeLastCardGridline);
		resizeListenerRegistered = true;
	}
};
